import React from 'react';

import { useQueryParam } from 'src/hooks/useQueryParam';

export const RedirectToFirstPage: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { setPage } = useQueryParam();

  React.useEffect(() => {
    setPage(1);
  }, [setPage]);

  return null;
};
